module.exports = __webpack_public_path__ + "img/DE03969.4f8ff7e8.png";